import { CollectionTargetLocation, ContentCollection } from 'craft/types';

export interface FallbacksEditorProps {
  context?: {
    isPopover?: boolean;
  };
  collections: ContentCollection[];
  setCustom: (custom: Record<string, any>) => void;
  nodeIds: string[];
  sortOrder: CollectionTargetLocation[];
}

export type FieldData = {
  targetLocation: CollectionTargetLocation;
  fallback?: string;
};

export enum VisibilityOptions {
  HIDE = 'hide',
  SHOW = 'fallback',
}

export type VisibilityOption = VisibilityOptions.HIDE | VisibilityOptions.SHOW;

export interface FallbacksEditorImplProps {
  collectionId?: string;
  hasFallback: boolean;
  fieldData: FieldData[];
  fallbackMappings: Record<CollectionTargetLocation, string | undefined> | Record<string, never>;
  onChangeVisibility: (value: VisibilityOption) => void;
  onSetImageFromLibrary: (targetLocation: CollectionTargetLocation, url: string) => void;
  onBlur: (value: string, targetLocation: CollectionTargetLocation) => void;
  nodeIds: string[];
}
